import { whatsappUrl } from "@/mocks/serra";
import HeroScene from "./HeroScene";

export default function Hero() {
  return (
    <section
      id="top"
      className="relative min-h-screen flex items-center bg-bg overflow-hidden"
    >
      <div className="absolute inset-0 tech-grid"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-bg"></div>

      <div className="relative w-full px-6 lg:px-10 py-32">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">
          <div className="text-center lg:text-left">
            <h1 className="text-white font-bold leading-[1.08] mb-8 text-4xl sm:text-5xl lg:text-6xl">
              Posicionamos empresas no digital.{" "}
              <span className="text-orange">Transformamos tecnologia em crescimento.</span>
            </h1>

            <p className="text-white/60 text-lg lg:text-xl mb-10 max-w-xl mx-auto lg:mx-0 leading-relaxed">
              Criamos sites, sistemas personalizados, estratégias digitais e
              plataformas inteligentes para empresas que desejam crescer de
              forma escalável.
            </p>

            <div className="flex flex-col sm:flex-row items-center lg:items-start justify-center lg:justify-start gap-4">
              <a
                href={whatsappUrl}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 font-medium rounded-full bg-orange hover:bg-coral text-bg px-8 py-4 text-base transition-colors duration-300 cursor-pointer whitespace-nowrap"
              >
                Fale Conosco
              </a>
              <a
                href="#servicos"
                className="inline-flex items-center justify-center gap-2 font-medium rounded-full border border-white/20 hover:border-cyan hover:text-cyan text-white px-8 py-4 text-base transition-colors duration-300 cursor-pointer whitespace-nowrap"
              >
                Conhecer nossos serviços
              </a>
            </div>
          </div>

          <div className="relative h-[420px] sm:h-[480px] lg:h-[560px]">
            <HeroScene />
          </div>
        </div>
      </div>
    </section>
  );
}
